import { isArray } from 'lodash-es';

export function castToStringArray(value: string | Array<string>): Array<string> {
  if (isArray(value)) {
    return value as Array<string>;
  }

  return [value as string];
}
